import { render, staticRenderFns } from "./ContactBlocked.vue?vue&type=template&id=28ac1b08&scoped=true&"
import script from "./ContactBlocked.vue?vue&type=script&lang=js&"
export * from "./ContactBlocked.vue?vue&type=script&lang=js&"
import style0 from "./ContactBlocked.vue?vue&type=style&index=0&id=28ac1b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac1b08",
  null
  
)

export default component.exports